/**
 *
 *   id?: string;
 *   unno: number;
 *   name?: string;
 *   class?: string;
 *   label?: string;
 *   packingGroup: number;
 *   hazardIdentificationNumber?: string;
 *   transportCategory?: string;
 *   updated?: string;
 */
export class DangerousGoodsModel {
	constructor(
		public hazardIdentificationNumber?: number,
		/**
		 * The goods that's transported
		 */
		public unno?: number,
		public name?: string,
	) {
	}

	fromJSON(dangerousGoods: {[key: string]: any}): DangerousGoodsModel {
		Object.keys(dangerousGoods).forEach(key => {
			// @ts-ignore
			this[key] = dangerousGoods[key];
		});
		return this;
	}
}